import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FoodListPage } from '../menu/food-list/food-list.page';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TabButtonComponent } from '../components/tab-button/tab-button.component'; // Import your component
import { AppButtonComponent } from '../components/app-button/app-button.component';
import { AppLoaderComponent } from '../components/app-loader/app-loader.component';
import { ListItemComponent } from '../components/list-item/list-item.component';
import { MySubscriptionCardComponent } from '../components/my-subscription-card/my-subscription-card.component';
import { MenuItemComponent } from '../components/menu-item/menu-item.component';
import { MacrosBarComponent } from '../components/marcos-bar/macros-bar.component';
import { TabBarComponent } from '../components/tab-bar/tab-bar.component';
import { CommentModalPage } from '../community/comment-modal/comment-modal.page';
import { PostModalPage } from '../community/post-modal/post-modal.page';
import { PopupModalComponent } from '../components/popup-modal/popup-modal.component';
import { AppSliderComponent } from '../components/app-slider/app-slider.component';
import { AreaListsPage } from '../pages/area-lists/area-lists.page';
import { TermsAndConditionsPage } from '../pages/terms-and-conditions/terms-and-conditions.page';
import { MenuDetailPage } from '../menu/menu-detail/menu-detail.page';
import { CustomLoaderComponent } from '../components/custom-loader/custom-loader.component';
import { EditAddressPage } from '../pages/edit-address/edit-address.page';
import { RewardItemComponent } from '../components/reward-item/reward-item.component';
import { RatingPage } from '../calendar/rating/rating.page';
import { SelectionPage } from '../calendar/selection/selection.page';
import { RatingComponentForm } from '../calendar/rating/component/rating-form.component';
import { AppStatComponent } from '../components/app-stat/app-stat.component';
import { AppRatingComponent } from '../components/app-rating/app-rating.component';


@NgModule({
    declarations: [AppRatingComponent, AppStatComponent , RatingPage, SelectionPage, RatingComponentForm,  PopupModalComponent, RewardItemComponent, CustomLoaderComponent, EditAddressPage, MenuDetailPage, TermsAndConditionsPage, AreaListsPage, AppSliderComponent, PopupModalComponent, CommentModalPage, PostModalPage, FoodListPage,TabBarComponent, TabButtonComponent, AppButtonComponent, AppLoaderComponent, ListItemComponent, MySubscriptionCardComponent, MenuItemComponent, MacrosBarComponent],
    imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		TranslateModule,
		ReactiveFormsModule,


    ],
    exports: [AppRatingComponent, AppStatComponent , RatingPage, SelectionPage, RatingComponentForm, PopupModalComponent, RewardItemComponent, CustomLoaderComponent,EditAddressPage, MenuDetailPage, TermsAndConditionsPage, AreaListsPage, PopupModalComponent, AppSliderComponent, CommentModalPage, PostModalPage,FoodListPage,TabBarComponent, TabButtonComponent, AppButtonComponent, AppLoaderComponent, ListItemComponent, MySubscriptionCardComponent, MenuItemComponent, MacrosBarComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }